import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance'; // Assuming you have an api instance configured
import type { PaymentMethod } from '@/types/payment-method';

interface PaymentMethodResponse {
  paymentMethods: PaymentMethod[];
}

const fetchBrandPaymentMethods = async (): Promise<PaymentMethodResponse> => {
  const response = await api.get<PaymentMethodResponse>('/dashboard/payment-methods');
  return response.data;
};

export const useBrandPaymentMethodsQuery = () => {
  return useQuery<PaymentMethodResponse, Error>({
    queryKey: ['brandPaymentMethods'],
    queryFn: fetchBrandPaymentMethods,
    // Add other options like staleTime, gcTime if needed
  });
};
